import { Alert } from '@mui/material';
import React, { memo } from 'react';
import { SignUpErrorCode } from 'shared/utils/errors';

import { t } from '@/services/translations/config';

import { Props } from './types';

function getSignUpErrorText(code: SignUpErrorCode) {
    switch (code) {
        case SignUpErrorCode.EmailInUse:
            return t('SignUp:error:email_is_already_used');

        case SignUpErrorCode.PhoneInUse:
            return t('SignUp:error:phone_number_has_been_taken');

        default:
            return t('Generic:error:server_encountered_temporary_error');
    }
}

function ServerErrorAlert({ code }: Props) {
    return (
        <Alert
            data-test-id="SignUpPage-ErrorAlert"
            severity="error"
            sx={{ mb: 4 }}
        >
            {getSignUpErrorText(code)}
        </Alert>
    );
}

export default memo(ServerErrorAlert);
